import LBox, { LBoxProps } from "@components/LBox";
import LIcon from "@components/LIcon";
import LLink from "@components/LLink";
import LPressable from "@components/LPressable";
import { theme } from "@theme";
import config from "@utils/config";
import { LinkProps } from "expo-router";
import { useTabBarHeight } from "@hooks/useTabBarHeight";
import { useActiveSongId } from "@utils/player";

type FloatingActionButtonProps = {
  style?: LBoxProps["style"];
  tipName?: string;
} & (
  | {
      href: LinkProps["href"];
      onPress?: never;
      sentryEventName?: never;
    }
  | { onPress: () => void; href?: never; sentryEventName: string }
);

const FloatingActionButton = ({
  href,
  style,
  onPress,
  sentryEventName,
  tipName: _tipName,
}: FloatingActionButtonProps) => {
  const activeSongId = useActiveSongId();
  const tabBarHeight = useTabBarHeight();

  const positionStyle = {
    position: "absolute",
    bottom:
      theme.spacing.m2 +
      (activeSongId
        ? config.UI.barMusicPlayerHeight + tabBarHeight
        : tabBarHeight),
    right: theme.spacing.s2,
  } as const;

  const content = (
    <LBox style={style}>
      <>
        <LIcon
          colors={{ background: theme.colors.saveBlue }}
          name="plus_circle"
          size={48}
        />
      </>
    </LBox>
  );

  if (href) {
    return (
      <LLink href={href} style={positionStyle} pressable={false}>
        {content}
      </LLink>
    );
  }

  if (onPress) {
    return (
      <LPressable
        sentryEventName={sentryEventName}
        onPress={onPress}
        style={positionStyle}
      >
        {content}
      </LPressable>
    );
  }
};

export default FloatingActionButton;
